import { render } from "./HeaderSection.vue?vue&type=template&id=3bbeba15"
import script from "./HeaderSection.vue?vue&type=script&lang=js"
export * from "./HeaderSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__